import {
  Globe, CalendarCheck, MessageCircle, Gift, QrCode, Star, Contact, Smartphone, Bot, Truck, CreditCard,
  LayoutGrid, ShoppingCart, ShoppingBag, BellRing, LayoutDashboard, BarChart3, Gamepad2, Flag, Disc3,
  Sparkles, Scissors, Stethoscope, UtensilsCrossed, Car, Store, GraduationCap, Building2, Scale, Plane,
  Radio, HardHat, Wrench, Users, RefreshCw, Rocket, Trophy, Goal, Swords, Target, Package, Zap, Heart,
} from "lucide-react";

export const ICONS = {
  Globe, CalendarCheck, MessageCircle, Gift, QrCode, Star, Contact, Smartphone, Bot, Truck, CreditCard,
  LayoutGrid, ShoppingCart, ShoppingBag, BellRing, LayoutDashboard, BarChart3, Gamepad2, Flag, Disc3,
  Sparkles, Scissors, Stethoscope, UtensilsCrossed, Car, Store, GraduationCap, Building2, Scale, Plane,
  Radio, HardHat, Wrench, Users, RefreshCw, Rocket, Trophy, Goal, Swords, Target, Package, Zap, Heart,
};

export const Icon = ({ name, ...props }) => {
  const C = ICONS[name] || Sparkles;
  return <C {...props} />;
};
